import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/bg-last-month.svg'


const _hoisted_1 = { class: "w-full flex flex-col" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "absolute inset-0 w-full h-full object-cover z-0"
}
const _hoisted_3 = { class: "absolute right-3 top-3 z-20" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-4 items-end z-10" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-4 z-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterMonthLeaderBoard = _resolveComponent("FilterMonthLeaderBoard")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_CardLiolio = _resolveComponent("CardLiolio")!
  const _component_CardRanking = _resolveComponent("CardRanking")!
  const _component_CardReward = _resolveComponent("CardReward")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "grid grid-cols-2 gap-6 relative p-3 rounded-3xl items-end",
      style: _ctx.headerStyle
    }, [
      (_ctx.isLastMonth)
        ? (_openBlock(), _createBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_FilterMonthLeaderBoard, { "onUpdate:month": _ctx.selectFilter }, null, 8, ["onUpdate:month"])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Skeleton, { height: "113px" }),
              _createVNode(_component_Skeleton, { height: "95px" })
            ]),
            _createVNode(_component_Skeleton, { height: "183px" })
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            (!_ctx.isCurrentMonth || _ctx.summaryData.isNoData)
              ? (_openBlock(), _createBlock(_component_CardLiolio, {
                  key: 0,
                  data: _ctx.summaryData,
                  month: _ctx.filterSummary.name
                }, null, 8, ["data", "month"]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_CardRanking, {
                data: _ctx.summaryData.cards.national
              }, null, 8, ["data"]),
              (_ctx.hasAreaOrNewPos)
                ? (_openBlock(), _createBlock(_component_CardRanking, {
                    key: 0,
                    data: _ctx.areaOrNewPosCard,
                    "is-new-pos": !!_ctx.summaryData.cards.newPos?.rank,
                    "is-right-podium": "",
                    "is-last-month-filter": _ctx.isLastMonth
                  }, null, 8, ["data", "is-new-pos", "is-last-month-filter"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isCurrentMonth && !_ctx.summaryData.isNoData)
              ? (_openBlock(), _createBlock(_component_CardReward, {
                  key: 1,
                  data: _ctx.summaryData
                }, null, 8, ["data"]))
              : _createCommentVNode("", true)
          ], 64))
    ], 4)
  ]))
}